import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app'
import {firebaseConnect} from '../lib/dbconfig'
import db from '../lib/db'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import firebase from 'firebase/app'
// import { firestorePlugin }  from 'vuefire'
// import 'firebase/firestore'

// Vue.use(firestorePlugin);
Vue.use(BootstrapVue);

Vue.config.productionTip = false

const initApp = () => {
  firebase.initializeApp(firebaseConnect);
  db.init();
  // firebase.functions().useFunctionsEmulator('http://localhost:5001') 
  console.log('looking ')
};

initApp();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
